import { render, staticRenderFns } from "./productMenu.vue?vue&type=template&id=14536494&scoped=true&"
import script from "./productMenu.vue?vue&type=script&lang=js&"
export * from "./productMenu.vue?vue&type=script&lang=js&"
import style0 from "./productMenu.vue?vue&type=style&index=0&id=14536494&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14536494",
  null
  
)

export default component.exports
import {QBtn,QMenu,QList,QItem,QItemSection,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBtn,QMenu,QList,QItem,QItemSection})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
